export const GET_BANNERS = "GET_BANNERS";
export const GET_BANNER_BY_ID = "GET_BANNER_BY_ID";
export const UPDATE_BANNER = "UPDATE_BANNER";
export const DELETE_BANNER = "DELETE_BANNER";
export const CREATE_BANNER = "CREATE_BANNER";
